import React from "react";

import {
    Button,
    ConfirmDialog,
    EmptyState,
    NotificationSnackbar,
    SectionCard,
    Skeleton,
    Stack,
} from "shared/ui";

import { CouponDialog } from "features/Coupons/components/CouponDialog";
import { CouponsFilters } from "features/Coupons/components/CouponsFilters";
import { CouponsTable } from "features/Coupons/components/CouponsTable";
import { CouponsContext } from "features/Coupons/context";
import { useCouponsState } from "features/Coupons/hooks/useCouponsState";

import { Container, Message } from "./styles";

const CouponsScreen = () => {
    const state = useCouponsState();

    if (state.loading) {
        return (
            <Container>
                <Stack>
                    <Skeleton height="44px" width="420px" />
                    <Skeleton height="360px" />
                </Stack>
            </Container>
        );
    }

    if (state.error) {
        return <Message>Не удалось загрузить промокоды</Message>;
    }

    const renderBody = () => {
        if (state.menuId === null) {
            return (
                <EmptyState
                    title="Нет меню"
                    description="Промокод действует внутри меню — сначала должно появиться хотя бы одно."
                />
            );
        }

        if (state.listError) return <Message>Не удалось загрузить промокоды</Message>;

        if (state.coupons.length === 0) {
            // Скелетон вместо пустоты: без него на время запроса мелькает «промокодов нет».
            if (state.listLoading) return <Skeleton height="360px" />;

            return state.typeFilter !== null ? (
                <EmptyState
                    title="Ничего не найдено"
                    description="В этом меню нет промокодов выбранного типа."
                    action={
                        <Button variant="text" onClick={() => state.setTypeFilter(null)}>
                            Показать все
                        </Button>
                    }
                />
            ) : (
                <EmptyState
                    title="Промокодов пока нет"
                    description="Промокод даёт гостю скидку на заказ — в процентах или суммой. Создайте первый."
                    action={<Button onClick={state.openCreateDialog}>Добавить промокод</Button>}
                />
            );
        }

        return <CouponsTable />;
    };

    return (
        <CouponsContext.Provider value={state}>
            <Container>
                <SectionCard
                    title="Скидки и промокоды"
                    description="Код, который гость вводит в корзине. Действует в выбранном меню до конца срока или до исчерпания лимита"
                    headerRight={
                        <Button
                            disabled={state.menuId === null}
                            onClick={state.openCreateDialog}
                        >
                            Добавить промокод
                        </Button>
                    }
                >
                    {/* Без меню фильтровать нечего: пустой селект и чипы только сбивают. */}
                    {state.menuId !== null && <CouponsFilters />}
                    {renderBody()}
                </SectionCard>

                {(state.dialog.kind === "createCoupon" ||
                    state.dialog.kind === "editCoupon") && <CouponDialog />}

                {state.dialog.kind === "deleteCoupon" && (
                    <ConfirmDialog
                        open
                        title="Удаление промокода"
                        description={`Промокод ${state.dialog.coupon.code} перестанет действовать, и гости больше не смогут его применить. Код останется занятым — повторно завести такой же не получится.`}
                        confirmLabel="Удалить"
                        saving={state.saving}
                        onClose={state.closeDialog}
                        onConfirm={state.confirmDelete}
                    />
                )}

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </CouponsContext.Provider>
    );
};

export const Coupons = CouponsScreen;
